import { useNavigate } from 'react-router-dom';

export default function BibliotecaEstrategica() {
  const navigate = useNavigate();

  return (
    <section id="biblioteca" className="bg-[#F8F6F3] py-28">
      <div className="max-w-7xl mx-auto px-8">

        {/* Encabezado */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#1A2B4A]/50 mb-4">
              Recursos profesionales
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2B4A] leading-tight mb-5">
              Biblioteca Estratégica<br />Internacional
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              Una colección de guías diseñadas para quienes buscan posicionarse con rigor en el mercado laboral europeo. Criterios reales de selección, contexto cultural y estrategia profesional en un único acceso.
            </p>
          </div>
          {/* Precio destacado */}
          <div className="flex-shrink-0">
            <div className="bg-[#1A2B4A] rounded-2xl px-10 py-8 text-center shadow-xl">
              <p className="text-white/50 text-xs uppercase tracking-widest mb-2">Acceso completo</p>
              <div className="flex items-end justify-center gap-1 mb-1">
                <span className="text-5xl font-extrabold text-white leading-none">29</span>
                <span className="text-2xl font-bold text-white mb-1">€</span>
              </div>
              <p className="text-white/60 text-xs">Pago único · Sin suscripción</p>
            </div>
          </div>
        </div>

        {/* Pilares de valor */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
          <div className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4A]/8 rounded-lg flex-shrink-0">
              <i className="ri-archive-line text-[#1A2B4A] text-xl"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900 mb-1">7 guías especializadas</p>
              <p className="text-xs text-gray-500 leading-relaxed">CV europeo, entrevistas internacionales y claves culturales por país.</p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4A]/8 rounded-lg flex-shrink-0">
              <i className="ri-refresh-line text-[#1A2B4A] text-xl"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900 mb-1">Actualizaciones incluidas</p>
              <p className="text-xs text-gray-500 leading-relaxed">El contenido evoluciona con las tendencias del mercado europeo.</p>
            </div>
          </div>
          <div className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
            <div className="w-10 h-10 flex items-center justify-center bg-[#1A2B4A]/8 rounded-lg flex-shrink-0">
              <i className="ri-lock-unlock-line text-[#1A2B4A] text-xl"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900 mb-1">Acceso permanente</p>
              <p className="text-xs text-gray-500 leading-relaxed">Disponible desde el momento del pago, sin caducidad ni suscripción.</p>
            </div>
          </div>
        </div>

        {/* Vista previa del contenido */}
        <div className="bg-white border border-gray-200 rounded-2xl p-10 mb-10 shadow-sm">
          <h3 className="text-lg font-bold text-gray-900 mb-2">Contenido incluido</h3>
          <p className="text-sm text-gray-500 mb-6">7 guías profesionales para posicionarte con ventaja en procesos internacionales</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-8">
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <i className="ri-file-text-line text-[#1A2B4A] text-lg"></i>
              </div>
              <span className="text-sm font-medium text-gray-900">CV europeo</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <i className="ri-user-voice-line text-[#1A2B4A] text-lg"></i>
              </div>
              <span className="text-sm font-medium text-gray-900">Entrevistas internacionales</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <span className="text-lg">🇩🇪</span>
              </div>
              <span className="text-sm font-medium text-gray-900">Claves Alemania</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <span className="text-lg">🇨🇭</span>
              </div>
              <span className="text-sm font-medium text-gray-900">Claves Suiza</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <span className="text-lg">🇳🇱</span>
              </div>
              <span className="text-sm font-medium text-gray-900">Claves Países Bajos</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <span className="text-lg">🇦🇹</span>
              </div>
              <span className="text-sm font-medium text-gray-900">Claves Austria</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1A2B4A]/10 rounded-lg flex-shrink-0">
                <span className="text-lg">🇧🇪</span>
              </div>
              <span className="text-sm font-medium text-gray-900">Claves Bélgica</span>
            </div>
          </div>
          <div className="text-center">
            <button
              onClick={() => navigate('/biblioteca-estrategica')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#1A2B4A] text-white text-sm font-semibold rounded-xl hover:bg-[#243550] transition-colors cursor-pointer whitespace-nowrap shadow-md"
            >
              Ver contenido completo
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        {/* CTA final */}
        <div className="bg-white border border-gray-200 rounded-2xl p-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 shadow-sm">
          <div className="max-w-xl">
            <p className="text-lg font-bold text-gray-900 mb-2">Accede a la colección completa</p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Un único pago de <strong className="text-gray-900">29€</strong> te da acceso inmediato y permanente a todas las guías, con actualizaciones futuras incluidas. Sin suscripciones ni costes adicionales.
            </p>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-2 flex-shrink-0">
            <div className="flex items-center gap-2 px-8 py-4 bg-[#1A2B4A]/10 border border-[#1A2B4A]/20 text-[#1A2B4A] text-sm font-semibold rounded-xl cursor-default whitespace-nowrap">
              <i className="ri-time-line"></i>
              Disponible próximamente
            </div>
            <p className="text-xs text-gray-400 tracking-wide">Lanzamiento oficial próximamente.</p>
          </div>
        </div>

      </div>
    </section>
  );
}